import React, { useState, useEffect } from "react";
import Header from "./Header";
import PageHeader from "./PageHeader";
import Sidebar from "./Sidebar";
import { useFilter } from "../../Context/FilterContext";
export default function AppContainer({
  title,
  previousPageTitle,
  actions = [],
  children,
}) {
  const [theme, setTheme] = useState(
    localStorage.getItem("FuelFy@theme") || "dark-theme"
  );
  const { toggleFilter } = useFilter();
  useEffect(() => {
    document.body.classList.remove("light-theme", "dark-theme");
    document.body.classList.add(theme);
    localStorage.setItem("FuelFy@theme", theme);
  }, [theme]);
  return (
    <div className="page">
      <Sidebar theme={theme} />
      <div className="main-content side-content pt-0">
        <Header theme={theme} setTheme={setTheme} />
        <div className="container-fluid">
          <PageHeader
            title={title}
            previousPageTitle={previousPageTitle}
            actions={actions}
          />
          {children}
        </div>
      </div>
      <footer className="main-footer text-center">
        <div className="container">
          <span>
            Copyright © {new Date().getFullYear()} &nbsp; Designed by
            <a href="https://www.Araknerd.com/">Araknerd company</a> All rights
            reserved.
          </span>
        </div>
      </footer>
    </div>
  );
}
